import React from "react"
import { useTranslation } from "react-i18next"
import { BiError } from "react-icons/bi"
import LittleCards from "../common/LittleCards"

const Misconceptions = () => {
  const { t } = useTranslation()

  return (
    <section className="mx-auto max-w-7xl p-8 space-y-4">
      <h2 className="text-xl md:text-2xl font-semibold">
        {t("introvert-insights.misconceptions.title")}
      </h2>
      <div className="py-5">
        <div className="flex items-center mb-5 bg-yellow-100 border border-yellow-300 p-3 rounded-md">
          <BiError className="text-yellow-500" size={48} />
          <p className="ml-3 text-lg ">
            {t("introvert-insights.misconceptions.alert")}
          </p>
        </div>
        <LittleCards
          items={t("introvert-insights.misconceptions.sectionMessage", {
            returnObjects: true,
          })}
          negative={true}
        />
        <div className="mt-5">
          <p className="text-lg">
            {t("introvert-insights.misconceptions.paragraph")}
          </p>
        </div>
      </div>
    </section>
  )
}

export default Misconceptions
